import React from 'react';
import './documentItem.scss';

function DocumentItem(props){

  return(
    <ul className="list-group document_item-list">
      {props.uploadedDocuments.map((file, i) =>{
        return(
          <li className=" text-success list-group-item d-flex justify-content-between align-items-center" key={`${i}-pom.xml`}>
            <span>{file.name}</span>
          </li>
        );
      })
      }
      {props.items.map((item, index) =>{
        return (item.files.map((file, i) =>{
          return(
            <li className="list-group-item d-flex justify-content-between align-items-center" key={`${index}-${i}-pom.xml`}>
              <span className="w-per-90">{file.name}</span>
              <span className="w-per-10">
                {/*<span className="action-right-icon">&#x2713;</span>*/}
                <span className="action-close-icon" tabIndex="0" onClick={()=>{
                  props.deleteItem(file.name);
                }}
                onKeyDown={e=> {
                  let key = e.keyCode;
                  key === 13 ? props.deleteItem(file.name) : null;
                  key === 32 ? props.deleteItem(file.name) : null;
                }} role="button" aria-label={`click to delete the uploaded document pom.xml`}>&#x2715;</span>
              </span>
            </li>
          );
        }));
      }
      )}
    </ul>
  );
}

export default DocumentItem;
